import React from 'react';
import './location.scss';
import { connect } from 'react-redux';
import history from 'hb-redux-store/history';
import Button from '../../components/common/Button/Button';
import {
  checkLocationPermission,
  getAddressFields,
  initializeMapNode,
  setMapCenter,
  getRecentSearches,
  GEOLOCATION_TIMEOUT,
} from 'hb-redux-store/util/locationService';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';
import { postUserLocation } from 'hb-redux-store/feature/home/home.action';
import Icon from '../../components/mweb/Icon/Icon';
import { setAppNotification } from 'hb-redux-store/initial.action';
// import {initializeMap} from "../../hb-redux-store/util/locationService";
import MarkerRadar from '../../components/common/MarkerRadar/MarkerRadar';
import AnalyticsService from '../../AnalyticsService';

const { geolocation = {} } = window?.navigator;
class Location extends React.Component {
  state = {
    locationDetails: null,
    primaryText: null,
    secondaryText: null,
    onMarkerChanged: 0,
    mapDragged: false,
    tooltipVisible: true,
    serviceableArea: false,
  };

  componentDidMount() {
    initializeMapNode(
      '.location-map--map-container--map#map',
      this.onMarkerChange,
      this.onDragStart
    )
      .then(locationDetails => {
        // console.log('locationDetails: ', locationDetails);
        // this.setLocationState(locationDetails);
      })
      .catch(e => {
        console.log('error: ', e);
        if (e === 'placeId not found') {
          history.goBack('/location');
        }
      });
  }

  onDragStart = () =>
    this.setState({ tooltipVisible: false, serviceableArea: false });

  onMarkerChange = locationDetails => {
    // console.log('New Marker details: ', getAddressFields(locationDetails));
    this.setLocationState(locationDetails);
  };

  setLocationState = locationDetails => {
    let addressFields = getAddressFields(locationDetails);
    const onMarkerChanged = this.state.onMarkerChanged + 1;
    const mapDragged = this.state.onMarkerChanged > 0;
    // console.log('new marker change and map dragged?', onMarkerChanged, mapDragged);
    if (!mapDragged) {
      const recentSearch = getRecentSearches();
      // console.log('Getting recent search: ', recentSearch);
      if (recentSearch.length > 0) {
        // console.log('recentSearch: ', recentSearch[0]);
        // console.log('addressFields: ', addressFields);
        addressFields.primaryText = recentSearch[0].mainText;
        addressFields.secondaryText = recentSearch[0].secondaryText;
        addressFields.area = addressFields.primaryText;
        addressFields.mapLocation = addressFields.secondaryText;
        addressFields.addressLine2 = addressFields.secondaryText;
      }
    }
    this.setState({
      locationDetails,
      // ...getAddressFields(locationDetails),
      ...addressFields,
      onMarkerChanged,
      mapDragged,
      tooltipVisible: true,
      serviceableArea: true,
    });
  };
  setLocation = () => {
    const { locationDetails, ...rest } = this.state;
    console.log('Selected Location: ', rest);
    this.props.postUserLocation(rest);
  };

  getCurrentLocation = () => {
    checkLocationPermission().then(result => {
      if (result.state === 'granted' || result.state === 'prompt') {
        geolocation.getCurrentPosition(
          position => {
            const gtmData = {
              eventName: 'locationSetCurrentLocation',
              eventData: {
                category: 'location > set_current_location',
                action: 'map_page',
                label: `lat: ${position.coords?.latitude}, long: ${position.coords?.longitude}`,
              },
            };
            AnalyticsService.trackGtmEvent(gtmData);
            setMapCenter({
              lat: position?.coords?.latitude,
              lng: position?.coords?.longitude,
            });
          },
          err => {
            this.props.setAppNotification(
              'Could not fetch current location. Try searching your location.'
            );
          },
          { timeout: GEOLOCATION_TIMEOUT }
        );
      } else if (result.state === 'denied') {
        this.props.setAppNotification('Location permission is denied.');
      }
    });
  };

  render() {
    const { primaryText, secondaryText, tooltipVisible } = this.state;
    return (
      <div className="location-map">
        <SecondaryNav
          title="Select Address"
          showTitle={true}
          capitalize
          showCart={false}
          showSearch={false}
        />
        <div className="location-map--map-container">
          <div id="map" className="location-map--map-container--map" />
          <MarkerRadar tooltipVisible={tooltipVisible} />
          {geolocation && (
            <div
              className="location-map--map-container--crosshair"
              onClick={this.getCurrentLocation}
            >
              <Icon class="icon-location-crosshair" size={30} />
            </div>
          )}
        </div>
        {this.state.locationDetails && (
          <div className="location-map--details">
            <Icon class="icon-location-bar-location-marker" size={30} />
            {/*<div className="icon-30 icon-location-bar-location-marker"></div>*/}
            <div className="location-map--details--address">
              <div className="justify-content--space-between">
                <div className="location-map--details--primary-text">
                  {primaryText}
                </div>
                <Button
                  onClick={history.goBack}
                  className="button action-link more"
                >
                  Change
                </Button>
              </div>
              <div className="location--map--details--secondary-text">
                {secondaryText}
              </div>
            </div>
          </div>
        )}
        <div className="bottom-sticky-cta">
          <Button
            type="submit"
            className="button button-primary full-width large"
            onClick={this.setLocation}
            disabled={!this.state.serviceableArea}
          >
            Confirm Location
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ homeReducer }) => ({});

const mapDispatchToProps = { postUserLocation, setAppNotification };

export default connect(mapStateToProps, mapDispatchToProps)(Location);
